var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C7.04686 0 5.17371 0.758569 3.79263 2.10883C2.41156 3.45909 1.63567 5.29044 1.63567 7.2V11.0416L0.0580706 14.904C0.00865911 15.0253 -0.00963531 15.1566 0.0047839 15.2864C0.0192031 15.4162 0.0658977 15.5406 0.140792 15.6487C0.215687 15.7568 0.316505 15.8453 0.434447 15.9065C0.552389 15.9678 0.68387 15.9999 0.817415 16H17.1826C17.3161 15.9999 17.4476 15.9678 17.5656 15.9065C17.6835 15.8453 17.7843 15.7568 17.8592 15.6487C17.9341 15.5406 17.9808 15.4162 17.9952 15.2864C18.0096 15.1566 17.9913 15.0253 17.9419 14.904L16.3643 11.04V7.2C16.3643 5.29044 15.5884 3.45909 14.2074 2.10883C12.8263 0.758569 10.9531 0 9 0ZM9 20C8.27424 20.0002 7.569 19.7645 6.99518 19.3301C6.42136 18.8956 6.01151 18.287 5.83007 17.6H12.1699C11.9885 18.287 11.5786 18.8956 11.0048 19.3301C10.431 19.7645 9.72576 20.0002 9 20Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.9d4b41feffb36fa9bd770b89dd85cd81.svg";
export { ForwardRef as ReactComponent };